const VALID_GENDERS = new Set(['undefined', 'male', 'female', 'other']);

const GENDER_ALIASES = {
  m: 'male',
  f: 'female',
  man: 'male',
  woman: 'female',
};

export function normalizePassengerGender(value) {
  if (value == null) return null;
  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return null;
  const mapped = GENDER_ALIASES[normalized] || normalized;
  return VALID_GENDERS.has(mapped) ? mapped : null;
}

export function normalizePassengers(passengers) {
  if (!Array.isArray(passengers)) return passengers;
  return passengers.map((passenger) => {
    if (!passenger || typeof passenger !== 'object') return passenger;
    const copy = { ...passenger };
    const gender = normalizePassengerGender(copy.gender);
    if (gender == null) {
      delete copy.gender;
    } else {
      copy.gender = gender;
    }
    return copy;
  });
}
